"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollectionVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _VariableType = require("../VariableType");
var _remeda = require("remeda");
var _fastDeepEqual = _interopRequireDefault(require("fast-deep-equal"));
var _types = require("../../types");
class CollectionVariable extends _VariableType.VarsValueVariableType {
  constructor() {
    super();
    (0, _defineProperty2.default)(this, "settings", CollectionVariable.settings);
    (0, _defineProperty2.default)(this, "type", "collection");
    (0, _defineProperty2.default)(this, "valueType", "value");
    (0, _defineProperty2.default)(this, "label", "collection");
    (0, _defineProperty2.default)(this, "description", "Variable that collects the values from collection-item variables.");
  }
  dependencies(params, resolver) {
    let list = resolver.resolveCollectionItems(params.name);
    return {
      name: params.name,
      list,
      includeMissing: params.includeMissing,
      unique: params.unique
    };
  }
  value(deps, batcher) {
    let values = [];
    for (let it of deps.list) {
      let val = it === null || it === void 0 ? void 0 : it.value();
      if (_types.vals.isMeta(val) && _types.vals.metaType(val) === "collection-item") {
        if (_types.vals.meta(val, "enabled")) {
          values.push(_types.vals.value(val));
        } else if (deps.includeMissing) {
          values.push(null);
        }
      } else if (deps.includeMissing) {
        values.push(null);
      }
    }
    if (deps.unique) {
      values = (0, _remeda.uniqWith)(values, _fastDeepEqual.default);
    }
    return values;
  }
}
exports.CollectionVariable = CollectionVariable;
(0, _defineProperty2.default)(CollectionVariable, "settings", {
  name: {
    type: "literal",
    title: "Collection Name",
    description: "Name of this collection.",
    valueType: "string"
  },
  includeMissing: {
    type: "toggle",
    title: "Include missing values",
    description: "If checked, missing values will be included as empty or null values."
  },
  unique: {
    type: "toggle",
    title: "Only unique values",
    description: "If checked, all duplicate values will be removed from the list."
  }
});
//# sourceMappingURL=CollectionVariable.js.map